import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RcFormControlAbstract} from '../rc-form-control-abstract/rc-form-control-abstract';

/**
 *
 * Rc textarea component
 *
 * @example
 * <lib-rc-text-area [control]="textAreaControl"></lib-rc-text-area>
 */
@Component({
    selector: 'lib-rc-text-area',
    template: `<div class="rc-textarea-wrapper">
  <div class="title-placeholder">
    <label *ngIf="label" [for]="elementId">{{label}}</label>
    <textarea
            id="{{elementId}}"
            class="form-control"
            maxlength="{{maxlength}}"
            [ngClass]="{'is-invalid': control.invalid && control.dirty && control.touched, 'have-value': control.value && control.value.toString().length}"
            [formControl]="control"
            (blur)="onBlur($event)"
            (focus)="onFocus($event)"
            attr.aria-label="{{ariaLabel}}"
            attr.aria-labeledby="{{ariaLabeledBy}}"
            attr.aria-describedby="{{getAriaDescribedBy()}}"
            (change)="onChange($event)"
            placeholder="{{ placeholder }}"
            rows="{{rows}}"
            (keydown)="onKeydown($event)"
            rc-textarea-autoresize
    >
    </textarea>
    <ng-container *ngIf="errorMsg">
      <div id="{{errorElementId}}" class="invalid-feedback-message" role="alert">{{ errorMsg }}</div>
    </ng-container>
  </div>
</div>
`,
    styles: [``]
})
export class RcTextareaComponent extends RcFormControlAbstract implements OnInit{


    /**
     * Text max length
     */
    @Input() maxlength: string;

    /**
     * placeholder
     */
    @Input() placeholder: string;

    /**
     * Textarea height by rows
     */
    @Input() rows: number;

    @Input() label: string;

    @Output() keyDownCallback: EventEmitter<any> = new EventEmitter();

    public onKeydown($event) {
        if (this.keyDownCallback.observers.length) {
            this.keyDownCallback.emit($event);
        }
    }

}
